import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import {
  ProductIcon,
  ProductDentalIcon,
  ProductVisionIcon,
} from '../EnrollmentIconsSvg';
import './styles/compare-plan-result-mobile.scss';

const ComparePlanResultPageMobile = ({
  setShowComparePlans,
  compareProductsPlans,
  compareProductTabName,
}) => (
  <div className="compare-plan-container-mobile">
    <div>
      <Row>
        <Col xs={12} className="compare-result-panel">
          <div className="compare-result-container">
            <div className="d-flex compare-title justify-content-between">
              <div>Compare Products</div>
              <div className="close-button">
                <GenericButton
                  type="button"
                  className="mr-0"
                  onClick={() => {
                    setShowComparePlans(false);
                  }}
                >
                  Close
                </GenericButton>
              </div>
            </div>

            <div className="compare-result-container-table">
              {compareProductsPlans &&
                compareProductsPlans.map((p) => (
                  <table
                    key={p.planId}
                    className="compare-result-container-pane"
                  >
                    <tr>
                      <th>Plans with Premiums</th>
                      <td>
                        <div className="column-header-title">
                          <div className="column-header-icon">
                            {compareProductTabName === 'medical' && (
                              <ProductIcon
                                classNameSecondary="card-view--icon-secondary"
                                classNamePrimary="card-view-icon"
                              />
                            )}
                            {compareProductTabName === 'dental' && (
                              <ProductDentalIcon
                                classNameSecondary="card-view--icon-secondary"
                                classNamePrimary="card-view-icon"
                              />
                            )}
                            {compareProductTabName === 'vision' && (
                              <ProductVisionIcon
                                classNameSecondary="card-view--icon-secondary"
                                classNamePrimary="card-view-icon"
                              />
                            )}
                          </div>
                          <span>{p.planTitle}</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>Tier Rating</th>
                      <td className="tier-rating-value">{p.tierRating}</td>
                    </tr>
                    <tr>
                      <th>Star Rating</th>
                      <td>{p.starRating}</td>
                    </tr>
                    <tr>
                      <th>Copay</th>
                      <td>{p.copay}</td>
                    </tr>
                    <tr>
                      <th>Coinsurance</th>
                      <td>{p.coinsurance}</td>
                    </tr>
                    <tr>
                      <th>Patients Responsibility</th>
                      <td>{p.patientResponsibility}</td>
                    </tr>
                    <tr>
                      <th colSpan={2} className="column-section-header">
                        In-network
                      </th>
                    </tr>
                    <tr>
                      <th>Deductible</th>
                      <td>{p.inNetworkDeductible}</td>
                    </tr>
                    <tr>
                      <th>Out-of-pocket</th>
                      <td>{p.inNetworkOutOfPocket}</td>
                    </tr>
                    <tr>
                      <th colSpan={2} className="column-section-header">
                        Out-of-network
                      </th>
                    </tr>
                    <tr>
                      <th>Deductible</th>
                      <td>{p.outOfNetworkDeductible}</td>
                    </tr>
                    <tr>
                      <th>Out-of-pocket</th>
                      <td>{p.outOfNetworkOutOfPocket}</td>
                    </tr>
                    <tr>
                      <th colSpan={2} className="column-section-header">
                        &nbsp;
                      </th>
                    </tr>
                    <tr>
                      <th>Primary Care Provider</th>
                      <td>
                        <span
                          className={
                            p.primaryCareProvider === 'Required'
                              ? 'required-text'
                              : 'not-required-text'
                          }
                        >
                          {p.primaryCareProvider}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th>Networks</th>
                      <td>
                        {p.networks &&
                          p.networks.length > 0 &&
                          p.networks.map((network, index) => (
                            <div key={index}>{network}</div>
                          ))}
                      </td>
                    </tr>
                    <tr>
                      <th>Generic Drugs</th>
                      <td>
                        {p.genricDrugs &&
                          p.genricDrugs.length > 0 &&
                          p.genricDrugs.map((drug, index) => (
                            <div key={index}>{drug}</div>
                          ))}
                      </td>
                    </tr>
                    <tr>
                      <th>Benefits</th>
                      <td>
                        <ul>
                          {p.benefits &&
                            p.benefits.length > 0 &&
                            p.benefits.map((benefit, index) => (
                              <li key={index}>{benefit}</li>
                            ))}
                        </ul>
                      </td>
                    </tr>
                  </table>
                ))}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
);
export default ComparePlanResultPageMobile;
